import _get from 'lodash/get';
import { Attachment } from 'graphql-common';

type ChipAttachment = Pick<Attachment, 'fileData'> | null | undefined;

// The attachment's MIME type — the same `fileData.data.metadata.mimeType`
// FileViewerModal picks its viewer from (`fileData` is a JSON scalar).
const getMimeType = (attachment: ChipAttachment) =>
  _get(attachment, ['fileData', 'data', 'metadata', 'mimeType']) as
    string | undefined;

// Only PDFs open at a page (FileViewerModal passes `initialPage` to PDFViewer
// alone), so only they get page-citation chips. Same check as FileViewerModal's
// PDF branch, so every file that opens in PDFViewer gets them.
export const isPdfAttachment = (attachment: ChipAttachment) =>
  !!getMimeType(attachment)?.includes('pdf');

// Only videos open at a moment (FileViewerModal passes `initialTime` to
// VideoViewer alone), so only they get time-citation chips. Same check as
// FileViewerModal's video branch.
export const isVideoAttachment = (attachment: ChipAttachment) =>
  !!getMimeType(attachment)?.startsWith('video');

// Material icon for a document chip, by the file's MIME type — the same checks
// FileViewerModal uses. Anything that isn't an image or a video (PDFs, office
// files) is a document.
export default function getDocChipIcon(attachment: ChipAttachment): string {
  const mimeType = getMimeType(attachment);
  if (mimeType?.includes('image')) return 'image';
  if (isVideoAttachment(attachment)) return 'videocam';
  return 'description';
}
